import withPage from '@lib/page';
import InterestProductPage from '@views/pages/account-interest-product';

export default withPage(InterestProductPage);
